import {
  Button,
  DatePicker,
  FormLayout,
  LegacyStack,
  Popover,
  Select,
  TextField,
} from "@shopify/polaris"
import { CalendarIcon } from "polaris-enhance"
// import classNames from "classnames"
import React, { Component } from "react"

import stores from "@/stores"
import { checkDatetimeFormat } from "@/utils/datetime"
import {
  disableShopTimeZoneFormatTime,
  shopTimeZoneFormatTime,
} from "@/utils/datetime"
import dayjs from "@/utils/dayjs"

import {
  Current,
  DefaultVal,
  IState,
  SelectedDates,
  TableDatePickerProp,
} from "./types"

// 日期选择范围
// const disableDatesBefore = disableShopTimeZoneFormatTime(
//   dayjs().tz(stores.UserInfoStore.data.iana_timezone),
//   true,
// )
// const disableDatesAfter = disableShopTimeZoneFormatTime(
//   dayjs().tz(stores.UserInfoStore.data.iana_timezone),
//   false,
// )

// 校验文本提示
// const TextErrorMsg = {

//   format: "Must match {format} format",
//   // todo 命名规范 及 动态参数 days
//   over: "Only supports dates within 90 days of history",
// }

// 默认选中的

export const defaultSelected: number = 30

export const TableDatePickerSelectedDates: SelectedDates = {
  end: dayjs().tz(stores.UserInfoStore.data.iana_timezone),
  start: dayjs().tz(stores.UserInfoStore.data.iana_timezone),
}

class TableDatePicker extends Component<TableDatePickerProp, IState> {
  defaultVal: DefaultVal = {
    endDate: dayjs().tz(stores.UserInfoStore.data.iana_timezone),
    startDate: dayjs()
      .tz(stores.UserInfoStore.data.iana_timezone)
      .subtract(defaultSelected - 1, "day"),
  }

  day2text = {
    "1": t("HereIsYourReturnPerformanceForToda"),
    "7": t("HereIsYourReturnPerformanceForThe"),
    "30": t("HereIsYourReturnPerformanceForThe0"),
    "60": t("HereIsYourReturnPerformanceForThe1"),
    "90": t("HereIsYourReturnPerformanceForThe2"),
    "-1": t("HereIsYourReturnPerformanceForAll"),
  }

  state: IState = {
    allowRange: true,
    changeDate: true,
    dayRangeText: this.day2text[defaultSelected],
    current: {
      month: this.defaultVal.startDate.month(),
      year: this.defaultVal.startDate.year(),
    },
    dateRange: [
      {
        label: t("Today"),
        value: "1",
      },
      {
        label: t("Last_7Days"),
        value: "7",
      },
      {
        label: t("Last_30Days"),
        value: "30",
      },
      {
        label: t("Last_60Days"),
        value: "60",
      },
      {
        label: t("Last_90Days"),
        value: "90",
      },
      {
        label: t("Last_180Days"),
        value: "180",
      },
    ],
    date_commenced: this.defaultVal.startDate.format("YYYY-MM-DD").toString(),

    endText: this.defaultVal.endDate.format("YYYY-MM-DD").toString(),

    end_commenced: this.defaultVal.endDate.format("YYYY-MM-DD").toString(),

    hasCustomOption: false,

    onceNumber: 0,

    popoverActive: false,

    selected: defaultSelected.toString(),

    selectedButtonText: t("LastSelectedDays", {
      replace: {
        x: defaultSelected,
      },
    }),

    selectedDates: {
      end: shopTimeZoneFormatTime(this.defaultVal.endDate),
      start: shopTimeZoneFormatTime(this.defaultVal.startDate),
    },

    disableDatesBefore: disableShopTimeZoneFormatTime(
      dayjs().tz(stores.UserInfoStore.data.iana_timezone),
      true,
    ),

    disableDatesAfter: disableShopTimeZoneFormatTime(
      dayjs().tz(stores.UserInfoStore.data.iana_timezone),
      false,
    ),

    selectedText: t("LastSelectedDays", {
      replace: {
        x: defaultSelected,
      },
    }),

    // 默认选中 Last 30 days
    // 开始时间选择过去30天前
    startText: this.defaultVal.startDate.format("YYYY-MM-DD").toString(),

    textError: "",

    value_commenced: "0",
  }

  // 设置是否显示
  setPopoverActive = (popoverActive: boolean) => {
    this.setState(() => ({ popoverActive }))

    // 记录历史时间
    if (popoverActive && this.state.onceNumber < 1) {
      this.setState((prevState) => ({
        date_commenced: prevState.startText,
        end_commenced: prevState.endText,
        onceNumber: prevState.onceNumber + 1,
        value_commenced: prevState.selected,
      }))
    }
  }

  togglePopoverActive = () => {
    this.setPopoverActive(!this.state.popoverActive)
    this.setState({ onceNumber: 0 })
  }

  public componentDidUpdate(
    prevProps: Readonly<TableDatePickerProp>,
    prevState: Readonly<IState>,
  ) {
    const booleans = [
      prevState.startText !== this.state.startText,
      prevState.endText !== this.state.endText,
    ]

    // 如果其中一个文本发生变化了，就更新值
    if (booleans.includes(true)) {
      TableDatePickerSelectedDates.start = this.state.selectedDates.start
      TableDatePickerSelectedDates.end = this.state.selectedDates.end
    }
  }

  public componentDidMount() {
    TableDatePickerSelectedDates.start = this.state.selectedDates.start
    TableDatePickerSelectedDates.end = this.state.selectedDates.end
    // 设置默认值
    this.setState({
      selectedButtonText: t("LastSelectedDays", {
        replace: {
          x: defaultSelected,
        },
      }),
    })
  }

  public componentWillUnmount() {}

  render() {
    const activator = (
      <div className="date-picker-container">
        <Button icon={CalendarIcon} onClick={this.togglePopoverActive}>
          {this.state.selectedButtonText}
        </Button>
      </div>
    )

    return (
      <div className={"flex flex-wrap items-center gap-4"}>
        <Popover
          activator={activator}
          active={this.state.popoverActive}
          ariaHaspopup={false}
          fluidContent
          onClose={this.togglePopoverActive}
          preferredAlignment="center"
        >
          <div className="md:w-[540px]">
            <Popover.Pane sectioned>
              <FormLayout>
                {this.dateRangeSelected()}
                {this.dateRangeTextField()}
                {this.datePicker()}
              </FormLayout>
            </Popover.Pane>
            <Popover.Pane sectioned>{this.dateButton()}</Popover.Pane>
          </div>
        </Popover>
      </div>
    )
  }

  /**
   * 下拉列表选择器
   */
  dateRangeSelected() {
    return (
      <Select
        label={t("DateRange")}
        onChange={this.handleSelectChange}
        options={this.state.dateRange}
        value={this.state.selected}
      />
    )
  }

  /** 处理下拉选择器变化事件 */
  handleSelectChange = (selected: string) => {
    this.setPopoverActive(false)

    // eslint-disable-next-line prefer-const
    let _selected = parseInt(selected),
      selectedText: string

    const selectedDates = {
      end: shopTimeZoneFormatTime(
        dayjs().tz(stores.UserInfoStore.data.iana_timezone),
      ),
      start: shopTimeZoneFormatTime(
        dayjs()
          .tz(stores.UserInfoStore.data.iana_timezone)
          .subtract(_selected - 1, "day"),
      ),
    }

    // -1为all time
    // if (-1 === _selected) {
    //   selectedDates.start = dayjs.unix(stores.UserInfoStore.data.created_at).toDate()
    // }

    if (_selected !== 0 && this.state.hasCustomOption) {
      this.setState({
        dateRange: this.state.dateRange.slice(0, -1),
        hasCustomOption: false,
      })
    }

    // eslint-disable-next-line prefer-const
    selectedText = this.getSelectedTextBtn(_selected)

    this.setState(
      {
        selected,
        selectedButtonText: selectedText,
        selectedDates,
        selectedText,
        dayRangeText: this.day2text[selected],
      },
      () => {
        this.props.onChange?.(
          _selected,
          dayjs(selectedDates.start)
            .tz(stores.UserInfoStore.data.iana_timezone)
            .startOf("d")
            .toDate(),
          dayjs(selectedDates.end)
            .tz(stores.UserInfoStore.data.iana_timezone)
            .startOf("d")
            .toDate(),
        )

        this.dateChangeHandle(true)

        stores.EventsStore.setSelected(this.state.selected)
        stores.EventsStore.setStartTime(void 0)
        stores.EventsStore.setEndTime(void 0)
      },
    )
  }

  /**
   * 日期范围文本框
   */
  dateRangeTextField() {
    return (
      <div className="flex justify-between items-center">
        <div className={"pr-8"} style={{ flex: "1" }}>
          <TextField
            autoComplete="off"
            label={t("Starting")}
            maxLength={10}
            minLength={10}
            onChange={(startText: string) => {
              this.setState(() => ({ startText }), this.dateRangeTextHandle)
            }}
            placeholder={"YYYY-MM-DD"}
            value={this.state.startText}
          />
        </div>
        <div style={{ flex: "1" }}>
          <TextField
            autoComplete="off"
            label={t("Ending")}
            maxLength={10}
            minLength={10}
            onChange={(endText: string) =>
              this.setState(() => ({ endText }), this.dateRangeTextHandle)
            }
            placeholder={"YYYY-MM-DD"}
            value={this.state.endText}
          />
        </div>
      </div>
    )
  }

  /**
   * 日期范围文本处理，如果变化了就同步到日历选择
   */
  dateRangeTextHandle() {
    const selectedDates: SelectedDates = {
      end: this.state.selectedDates.end,
      start: this.state.selectedDates.start,
    }

    let startText: string | null = null,
      endText: string | null = null

    let startDayjs: dayjs.Dayjs | null = checkDatetimeFormat(
        "YYYY-MM-DD",
        this.state.startText,
      ),
      endDayjs: dayjs.Dayjs | null = checkDatetimeFormat(
        "YYYY-MM-DD",
        this.state.endText,
      )

    if (null !== startDayjs) {
      // 如果开始日期 小于 所规定的最小日期
      if (startDayjs.isBefore(this.state.disableDatesBefore)) {
        startText = this.state.disableDatesBefore.format("YYYY-MM-DD")
        startDayjs = this.state.disableDatesBefore
      }

      selectedDates.start = startDayjs.toDate()
    }

    if (null !== endDayjs) {
      // 如果结束日期 打于 所规定的最大日期
      if (endDayjs.isAfter(this.state.disableDatesAfter)) {
        endDayjs = this.state.disableDatesAfter
        endText = this.state.disableDatesAfter.format("YYYY-MM-DD")
      }

      selectedDates.end = endDayjs.toDate()
    }

    const selectedText = `${dayjs(selectedDates.start)
      .format("MMM D, YYYY")
      .toString()} - ${dayjs(selectedDates.end)
      .format("MMM D, YYYY")
      .toString()}`

    // 处理文本框内容
    let otherStates = {}

    if (startText) otherStates = { startText }
    if (endText) otherStates = { ...otherStates, endText }

    // 处理 选中 最开始的年月
    if (startDayjs)
      otherStates = {
        ...otherStates,
        current: {
          month: startDayjs.month(),
          year: startDayjs.year(),
        },
      }
    if (!this.state.hasCustomOption) {
      this.setState({
        dateRange: [
          ...this.state.dateRange,
          {
            label: t("Custom"),
            value: "0",
          },
        ],
        hasCustomOption: true,
      })
    }
    // 处理完成后，执行获取图表数据接口
    this.setState(() => ({
      selected: "0",
      selectedDates,
      selectedText,
      ...otherStates,
    }))
  }

  /**
   * 日期选择器
   */
  datePicker() {
    return (
      <DatePicker
        allowRange
        disableDatesAfter={this.state.disableDatesAfter.toDate()}
        disableDatesBefore={this.state.disableDatesBefore.toDate()}
        month={this.state.current.month}
        multiMonth
        onChange={(selectedDates: SelectedDates) => {
          const changeDate = false
          const selectedText = `${dayjs(selectedDates.start)
            .format("MMM D, YYYY")
            .toString()} - ${dayjs(selectedDates.end)
            .format("MMM D, YYYY")
            .toString()}`

          if (!this.state.hasCustomOption) {
            this.setState({
              dateRange: [
                ...this.state.dateRange,
                {
                  label: t("Custom"),
                  value: "0",
                },
              ],
              hasCustomOption: true,
            })
          }
          this.setState(
            () => ({ changeDate, selected: "0", selectedDates, selectedText }),
            this.dateChangeHandle,
          )
        }}
        onMonthChange={(month: any, year: any) =>
          this.setState(() => ({ current: { month, year } }))
        }
        selected={this.state.selectedDates}
        year={this.state.current.year}
      />
    )
  }

  /**
   * button按钮
   */
  dateButton() {
    const Cancel = () => {
      this.setState(
        (state) => ({
          changeDate: true,
          endText: state.end_commenced,
          selected: state.value_commenced,
          selectedDates: {
            end: dayjs(this.state.end_commenced)
              .tz(stores.UserInfoStore.data.iana_timezone)
              .toDate(),
            start: dayjs(state.date_commenced)
              .tz(stores.UserInfoStore.data.iana_timezone)
              .toDate(),
          },
          startText: state.date_commenced,
        }),
        () => {
          this.setPopoverActive(false)
        },
      )
    }

    const Apply = () => {
      this.setPopoverActive(false)
      this.props.onChange?.(
        0,
        dayjs(this.state.selectedDates.start)
          // .tz(stores.UserInfoStore.data.iana_timezone)
          .startOf("d")
          .toDate(),
        dayjs(this.state.selectedDates.end)
          // .tz(stores.UserInfoStore.data.iana_timezone)
          .startOf("d")
          .toDate(),
      ) // 回调
      this.setState({
        changeDate: true,
        selectedButtonText: this.state.selectedText,
        dayRangeText: t("HereIsYourReturnPerformanceForThis", {
          replace: {
            x: this.state.selectedText,
          },
        }),
      })
      if (this.state.selected === "0") {
        setTimeout(() => {
          stores.EventsStore.setStartTime(this.state.startText)
          stores.EventsStore.setEndTime(this.state.endText)
          stores.EventsStore.setSelected(void 0)
        }, 1)
      }
    }

    return (
      <LegacyStack distribution="equalSpacing">
        <Button onClick={Cancel}>{t("Cancel")}</Button>
        <Button
          disabled={
            this.state.date_commenced === this.state.startText &&
            this.state.end_commenced === this.state.endText &&
            this.state.changeDate
          }
          onClick={Apply}
          variant="primary"
        >
          {t("Apply")}
        </Button>
      </LegacyStack>
    )
  }

  /**
   * 日期改变处理事件
   * @private
   */
  private dateChangeHandle(refreshC: boolean = false): void {
    this.setSelectedTexts()
    if (refreshC) this.setCurrentMonthYear()
  }

  /**
   * 设置选中的文本信息
   * @private
   */
  private setSelectedTexts(): void {
    this.setState(() => ({
      endText: dayjs(this.state.selectedDates.end)
        .format("YYYY-MM-DD")
        .toString(),
      startText: dayjs(this.state.selectedDates.start)
        .format("YYYY-MM-DD")
        .toString(),
    }))
  }

  /**
   * 设置当前选择的年月
   * @private
   */
  private setCurrentMonthYear() {
    const startDayjs = dayjs(this.state.selectedDates.start).tz(
      stores.UserInfoStore.data.iana_timezone,
    )
    const current: Current = {
      month: startDayjs.month(),
      year: startDayjs.year(),
    }

    this.setState(() => ({ current }))
  }

  public getSelectedTextBtn(selected: number): string {
    let selectedText: string

    switch (selected) {
      // case -1:
      //   selectedText = "All time"
      //   break
      case 0:
        // eslint-disable-next-line prefer-destructuring
        selectedText = this.state.selectedText
        break
      case 1:
        selectedText = t("Today")
        break
      default:
        selectedText = t("LastSelectedDays", {
          replace: {
            x: selected,
          },
        })
    }

    return selectedText
  }
}

export default TableDatePicker
